import React, { useContext, useEffect, useState } from 'react'
import { OverlayLoader, Spinner } from '../../Components/Shimmers'
import AccountSiderBar from "./AccountSideBar";
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { ConfigContext } from '../../Context/ConfigContext';
import dayjs from "dayjs";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { axiosGet } from '../../Apis/axiosMethods';

const RequestCreditList = () => {

    const { t } = useTranslation();
    const { apiB2BURL, apiHeaderJson } = useContext(ConfigContext);
    const dir = localStorage.getItem('dir');

    const [requests, setRequests] = useState([]);
    const [requestsLoading, setRequestsLoading] = useState(true);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);

    const getData = async () => {
        try {
            setLoading(true);
            const response = await axiosGet(`/Dashboard/GetCreditRequets`);
            const { success, data } = response.data;

            if (success) {
                setRequests(data);
                setHasMore(data.length >= limit);
            }

        } catch (error) {
            console.error("Error fetching credit requests:", error);
        } finally {
            setRequestsLoading(false);
            setLoading(false);
        }
    }

    const loadMore = () => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            getData(nextPage);
        }
    };

    const getStatusBadge = (status) => {
        let badgeClass = '';
        let statusText = '';

        switch (Number(status)) {
            case 0:
                badgeClass = 'badge-warning';
                statusText = t("Pending");
                break;
            case 1:
                badgeClass = 'badge-success';
                statusText = t("Approved");
                break;
            case 2:
                badgeClass = 'badge-danger';
                statusText = t("Rejected");
                break;
            default:
                badgeClass = 'badge-secondary';
                statusText = t("Unknown");
        }

        return (
            <span className={`badge ${badgeClass}`}>
                {statusText}
            </span>
        );
    };

    const statusMap = {
        0: "Pending",
        1: "Approved",
        2: "Rejected",
    };

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            requests.map(row => ({
                "ID": row.business_credit_application_id,
                "Company Name": row.business_credit_company_name,
                "Company Email": row.business_credit_company_email,
                "Request Date": dayjs(row.created_date).format("DD-MM-YYYY"),
                "Status": statusMap[row.business_credit_status] || "Unknown",
                "Amount": row.business_credit_amount,
                "Days": row.business_credit_days,
            }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Applications");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(data, "credit_applications.xlsx");
    };

    const downloadPDF = () => {
        const doc = new jsPDF();

        const tableColumn = [
            "ID",
            "Company Name",
            "Company Email",
            "Request Date",
            "Status",
            "Amount",
            "Days",
        ];

        const tableRows = requests.map(row => [
            row.business_credit_application_id,
            row.business_credit_company_name,
            row.business_credit_company_email,
            dayjs(row.created_date).format("DD-MM-YYYY"),
            statusMap[row.business_credit_status] || "Unknown",
            row.business_credit_amount,
            row.business_credit_days,
        ]);

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            theme: "grid",
            styles: { fontSize: 8 },
            headStyles: { fillColor: [41, 128, 185] },
        });

        doc.save("credit_applications.pdf");
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getData();
    }, []);

    return (
        <>
            {
                requestsLoading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main style={{ marginTop: '-10px' }}>
                        <div className="page-header">
                            <div className="container d-flex flex-column align-items-center">
                                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                                    <div className="container">
                                        <ol className="breadcrumb" dir={dir}>
                                            <li className="breadcrumb-item">
                                                <NavLink to={'/'}>{t("home")}</NavLink>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                {t("Credit Requests")}
                                            </li>
                                        </ol>
                                    </div>
                                </nav>
                                <h1>{t("Credit Requests")}</h1>
                            </div>
                        </div>
                        <div className="container account-container custom-account-container">
                            <div className="row">
                                <AccountSiderBar />
                                <div className="col-lg-12 order-lg-last order-1 tab-content">
                                    <div className="tab-pane fade show active" id="address" role="tabpanel">
                                        <div className="order-content">
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: '1rem'
                                            }}>
                                                <h3 className={`account-sub-title d-none d-md-block mb-0 ${dir === 'rtl' ? 'text-right' : ''}`} dir={dir}>
                                                    <i className="fas fa-credit-card align-middle mr-3" />
                                                    {"Credit Requests"}
                                                </h3>
                                                {requests.length > 0 && (
                                                    <div>
                                                        <label className="mr-2">{t("Download orders report")}: </label>
                                                        <button
                                                            onClick={downloadExcel}
                                                            className="btn btn-primary"

                                                            title={t("download_excel")}
                                                        >
                                                            <i className="fas fa-file-excel" style={{ color: '#FFF', fontSize: '1.2rem' }}></i> EXCEL
                                                        </button>
                                                        <button
                                                            onClick={downloadPDF}
                                                            className="btn btn-primary ml-2"

                                                            title={t("download_pdf")}
                                                        >
                                                            <i className="fas fa-file-pdf" style={{ color: '#FFF', fontSize: '1.2rem' }}></i> PDF
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="order-table-container text-center">
                                                <table className="table table-order text-left">
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Company Name</th>
                                                            <th>Company Email</th>
                                                            <th>Request Date</th>
                                                            <th>Request Amount</th>
                                                            <th>Approve Amount</th>
                                                            <th>Request Days</th>
                                                            <th>Approve Days</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {requests.length > 0 ? (
                                                            requests.map((row) => (
                                                                <tr key={row.business_credit_application_id}>
                                                                    <td>{row.business_credit_application_id}</td>
                                                                    <td>{row.business_credit_company_name}</td>
                                                                    <td>{row.business_credit_company_email}</td>
                                                                    <td className="order-date">{dayjs(row.created_date).format("DD-MM-YYYY")}</td>
                                                                    <td>AED {row.requested_credit_limit ?? row?.business_credit_amount}</td>
                                                                    <td>AED {row.approved_credit_limit ?? 0}</td>
                                                                    <td>{row.requested_due_days ?? row?.business_credit_days} Days</td>
                                                                    <td>{row.approved_due_days ?? 0} Days</td>
                                                                    <td>{getStatusBadge(row.request_status)}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td className="text-center p-0" colSpan={5}>
                                                                    <p className="mb-5 mt-5">{t("no_order_yet_made")}</p>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                <hr className="mt-0 mb-3 pb-2" />
                                                <div className="text-center">
                                                    {loading ? (
                                                        <Spinner />
                                                    ) : hasMore ? (
                                                        <button className="btn btn-xs btn-outline-primary" onClick={loadMore}>
                                                            {t("load_more")}
                                                        </button>
                                                    ) : (
                                                        <p className="text-muted">No more Requests</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
            }
        </>
    )
}

export default RequestCreditList